import Vue from 'vue';
import { CommonService } from '~/utils/common.service';
export default {
    install: function () {
        Vue.prototype.$common = CommonService;
    }
};
